import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// normalize.css
import 'normalize.css'
// element ui
import ElementUI from 'element-ui'
// element ui 变量覆盖
import '@style/element-variables.scss'
// 通用样式
import '@style/common.scss'
// 图标组件，注册到公共组件中
import 'remixicon/fonts/remixicon.css'
// 系统名称
import { systemName } from '@/config/system'

// 设置页面标题
window.document.title = systemName
Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
